import serializeError from 'serialize-error'
import Vue from 'vue'
import Axios from 'axios'
import store from '@/store'
import { TokenService } from '@/services/storage.service'

Axios.defaults.baseURL = __config.api_url
Axios.defaults.headers.common.Accept = 'application/json'

const { accessToken, tokenType } = store.state['authentication']
if (accessToken) {
  Axios.defaults.headers.common.Authorization = `${tokenType || 'Bearer'} ${accessToken}`
}
Axios.defaults.headers.common['X-Lang-TranslateList'] = true
Axios.defaults.headers.common['X-Lang-Display'] = 'ru'
Axios.defaults.headers.common['X-Lang-Fallback'] = 'en'
Axios.defaults.headers.common['X-Lang-Second'] = 'en'

Axios.interceptors.request.use(config => {
  return config
})

Axios.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  async error => {
    let { config, response } = error instanceof Error && error.response.status >= 500 ? serializeError(error) : error
    const originalRequest = config
    if (error instanceof Axios.Cancel) {
      return Promise.resolve(error)
    }
    if (response && response.status === 500) {
      store.commit('errors/setErrors', response)
    }
    if ((response && response.status === 403) || (response && response.status === 401)) {
      const userRequest = await fetch(`${Axios.defaults.baseURL}/api/auth/profile`, {
        method: 'get',
        headers: new Headers({
          'Authorization': Axios.defaults.headers.common.Authorization,
          'Content-Type': Axios.defaults.headers.common.Accept
        })
      })
      const userRequestBody = await userRequest.json()

      if (userRequestBody.error) {
        try {
          const { data: json } = await Axios.post(
            `${__config.api_url}/token/refresh`,
            `refresh_token=${TokenService.getRefreshToken()}`,
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          if (json.error) {
            await store.dispatch('authentication/logout')
            Vue.$router.push('/login')
            // throw new Error(json.error)
          }
          if (json.data) {
            const { token_type: tokenType, access_token: accessToken, refresh_token: refreshToken, expiry: expiryTokenDate } = json.data
            await store.dispatch('authentication/authenticate', {
              tokenType, accessToken, refreshToken, expiryTokenDate
            })
            const retryOriginalRequest = new Promise(resolve => {
              originalRequest.headers.Authorization = `${tokenType} ${accessToken}`
              resolve(Axios(originalRequest))
            })
            return retryOriginalRequest
          }
        } catch (e) {
          await store.dispatch('authentication/logout')
          window.location.replace(`/login`)
        }
      } else {
        return Promise.reject(response)
      }
    }
    return Promise.reject(response)
  }
)

Vue.$http = Axios
Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return Axios
  }
})

export default Vue.$http
